import { render, staticRenderFns } from "./ManageInfoTab.vue?vue&type=template&id=40b1dc5b&scoped=true"
import script from "./ManageInfoTab.vue?vue&type=script&lang=js"
export * from "./ManageInfoTab.vue?vue&type=script&lang=js"
import style0 from "./ManageInfoTab.vue?vue&type=style&index=0&id=40b1dc5b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b1dc5b",
  null
  
)

export default component.exports